import {game, staticPath, loadCss, loadJs} from 'promokit-util';
import localUserData from './localUserData';
import configCnb from './config.cnb';
import ConfigApi from './config.api';
import {signIn, signOut} from './config.sign';

if (!window.promokit) {
  const lan = staticPath().lan;
  const apiUrl = ConfigApi[game().en][lan];

  const cnbCss = `${staticPath().staticPath}/uikit/cnb/v2/css/nc-cnb.css`;
  const cnbJs = `${staticPath().staticPath}/uikit/cnb/v2/js/cnb.js`;

  const signInUrl = signIn[lan];
  const signOutUrl = signOut[lan];

  const getLocation = (href = document.location.href) => {
    let location = href;

    if (location !== '' && location.indexOf('#') > 0) {
      location = location.substring(0, location.lastIndexOf('#'));
    }

    return location;
  };

  //cnb start
  loadCss(cnbCss, () => {
    const body = $('body');
    body.prepend(`<div id="nc-cnb"></div>`);
    body.prepend(`<form name="FrmGNBLogout" id="FrmGNBLogout" method="post" action="${signOutUrl}"><input type="hidden" name="return_url" value="${getLocation()}" /></form>`);

    loadJs(cnbJs, () => {
      window.GNBLogin = function() {
        document.location.href = `${signInUrl}?site_id=31&return_url=${escape(getLocation())}`;
      };

      window.GNBLogout = function() {
        const FrmGNBLogout = $('#FrmGNBLogout');
        FrmGNBLogout.submit();
      };

      if (window.userData) {
        window.cnb.start(configCnb);
        return;
      }

      if (!apiUrl) {
        window.userData = localUserData;
        window.userData.isLogin = localUserData.login;
        window.cnb.start(configCnb);
        return;
      }
      $.ajax({
        url: apiUrl,
        xhrFields: {withCredentials: true}
      }).done(function(data) {
        if (game().en == 'aion') {
          data.gameAccount.subData[1].value = `Lv.${data.gameAccount.subData[1].value}`;
        }

        window.userData = data;

        if (data.login) {
          window.userData.isLogin = data.login;
        }

        window.cnb.start(configCnb);
      });
    });
  });

  //제제계정 본인확인 팝업 (리니지)
  window.openPopup = function(obj, objWidth, objHeight, objName, objScroll, deny, objFull, addParam) {
    try {
      if (objScroll !== 1 && objScroll !== 0 && objScroll !== '1' && objScroll !== '0') {
        var objScrollCopy = objScroll;
        objScroll = objName;
        objName = objScrollCopy;
      }

      var setup, win;

      if (typeof (obj) == 'string') {
        setup = 'width=' + objWidth + ',height=' + objHeight + ',toolbar=no,location=no,status=no,menubar=no,top=20,left=20,scrollbars=' + objScroll + ',resizable=no';
        if (objName == '' || !objName) objName = 'popup';
        if (objFull) setup = 'fullscreen=1,scrollbars=0';

        win = window.open(obj, objName, setup);
        if (win != null) win.focus();

        return win;
      }

      if (!objName) objName = 'popup';
      if (!objScroll) objScroll = 'auto';

      var url = addParam ? obj.href + '?' + addParam : obj.href;
      setup = 'width=' + objWidth + ',height=' + objHeight + ',toolbar=no,location=no,status=no,menubar=no,top=20,left=20,scrollbars=' + objScroll + ',resizable=no';

      if (objFull) setup = 'fullscreen=1,scrollbars=0';
      win = window.open(url, objName, setup);

      if (deny) {
        if (win == null) {
          alert('팝업 차단을 해제하여 주시기 바랍니다.');
        }
        else {
          win.focus();
        }
      }

      return win;

    }
    catch (e) {
      //
    }
  };
  window.openPopupUnban = function(url) {
    openPopup(url, 580, 370, 'unban', 1, 1);
    return false;
  };
}



